var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: { height: _vm.mapheight, width: "100%" } }, [
    _vm.overviewType === "设备概貌图" && _vm.showGraph
      ? _c("iframe", {
          style: {
            height: "100%",
            backgroundColor: _vm.nowImageBackground,
            width: "100%",
            border: 0
          },
          attrs: {
            id: "ProcessIframe",
            src: _vm.EquipmentIframeUrl,
            sandbox:
              "allow-scripts allow-same-origin allow-top-navigation allow-popups"
          }
        })
      : _vm.overviewType === "工艺流程图" && _vm.showGraph
        ? _c("iframe", {
            style: {
              height: "100%",
              backgroundColor: _vm.nowImageBackground,
              width: "100%",
              border: 0
            },
            attrs: {
              id: "ProcessOverviewIframe",
              src: _vm.ProcessIframeUrl,
              sandbox:
                "allow-scripts allow-same-origin allow-top-navigation allow-popups"
            }
          })
        : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73280dfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73280dfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComUtils/OverViewIframe.vue
// module id = null
// module chunks = 